import React from 'react';

import * as FileConstants from 'folder-items/FileConstants';
import TableCellWithTooltip from 'ui-library/scrollable/table-cells/TableCellWithTooltip';

import ComputedStateText from './ComputedStateText';
import * as ComputedTagUtil from './ComputedTagUtil';

export default function ComputedStateTableCell({tag}: {tag: FileConstants.ComputedSchemaTag}): JSX.Element {
  return (
    <TableCellWithTooltip tooltipTitle={ComputedTagUtil.computedStateExtraText(tag)}>
      <ComputedStateText computedState={tag.computedState} schemaFieldRenderData={tag.tagSchemaField} />
    </TableCellWithTooltip>
  );
}

ComputedStateTableCell.propTypes = {
  tag: FileConstants.TAG_SHAPE.isRequired,
};
